import React, {useEffect} from 'react'
import Banner from '../../Components/Banner'
import ReviewBox from '../../Components/ReviewBox'
import faqs from '../../Constants/faq'
import Sticky from 'sticky-js';
import $ from 'jquery';

interface Question {
    id: number
    question: string
    answer: string
}

interface FAQ {
    id: number
    category: string
    questions: Array<Question>
}

function Faq() {
    const data  = {
        title : 'Frequently Asked Questions',
        description: 'Consectetur adipisicing elit. Nihil, illum voluptate eveniet ex fugit ea delectus, sed voluptatem. Laborum accusantium libero commodi id officiis itaque esse adipisci, necessitatibus asperiores, illo odio.',
        navigation: [{path: '/faq', title: 'FAQ'}]
    }

    function submitQuestion (name: string, email: string, text : string) {
        let review = {name, email, text}
        console.log('New Question', review);
    }

    function showQuestion(question:Question) {
        return(
            <div className="card">
                <div className="card-header" id={`knsl-faqHeading-${question.id}`}>
                    <div className="mb-0">
                        <div className="knsl-faq-title" data-toggle="collapse" data-target={`#knsl-faqCollapse-${question.id}`} data-aria-expanded="true" data-aria-controls={`#knsl-faqCollapse-${question.id}`}>
                            <span className="badge">{question.id}</span>{question.question}
                        </div>
                    </div>
                </div>
                <div id={`knsl-faqCollapse-${question.id}`} className="collapse" aria-labelledby={`knsl-faqHeading-${question.id}`} data-parent="#accordion">
                    <div className="knsl-card-body">
                        <p>{question.answer}</p>
                    </div>
                </div>
            </div>
        )
    }

    function showFaq(faq:FAQ) {
        return(
            <React.Fragment key={faq.id}>
                <h3 className="knsl-mb-30">{faq.category}</h3>
                <div className="knsl-faq knsl-mb-60" id={`faq-${faq.id}`}>
                    {faq.questions.map((question:Question) => showQuestion(question))}
                </div>
            </React.Fragment>
        )
    }

    useEffect(() => {
        window.scrollTo(0, 0);
        let sticky = new Sticky('.knsl-sticky');
            if ($(window).width() < 992) {
                sticky.destroy();
            }
    }, [])

    return (
        <>
            <Banner data={data}/>

            <div className="container knsl-p-100-100">
                <div className="row" data-sticky-container>

                    <div className="col-lg-3">

                    {/* <!-- side form --> */}
                    <div className="knsl-sticky knsl-stycky-left" data-margin-top="110">

                        <h3 className="knsl-mb-30">Menu</h3>

                        <ul className="knsl-side-menu">
                            {faqs.map((faq:FAQ) => <li key={faq.id}><a href={`#faq-${faq.id}`} className="knsl-sm-link">{faq.category}</a></li>)}
                        </ul>

                    </div>
                    {/* <!-- side form end --> */}

                    </div>
                    <div className="col-lg-9">
                    <section>

                        <div id="accordion">

                            {faqs.map((faq:FAQ) => showFaq(faq))}
                            
                        </div>
                    </section>

                    <section>
                        <div className="row">
                        <div className="col-lg-12">
                            <h3 className="knsl-mb-40 knsl-scroll-animation">Didn't find the answer?</h3>
                        </div>
                        <ReviewBox onSubmit={submitQuestion} />
                        </div>
                    </section>

                    </div>
                </div>
                </div>
        </>
    );
}

export default Faq